/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/validators.ts (Class of Services)
 🗓️ Created: 2025-01-27
 🧩 Description:
    Form validation utilities for Class of Services.
────────────────────────────────────────────────────────────────*/

import { FormState, ValidationErrors } from '../types';

/**
 * Validate Class of Service form
 */
export function validateClassOfServiceForm(
  formData: FormState,
  t: (key: string) => string
): ValidationErrors {
  const errors: ValidationErrors = {};
  const name = formData.name.trim();

  if (!name) {
    errors.name = t('classOfServices.validation.nameRequired');
  } else if (name.length < 3) {
    errors.name = t('classOfServices.validation.nameMinLength');
  } else if (name.length > 100) {
    errors.name = t('classOfServices.validation.nameMaxLength');
  }

  return errors;
}

